import clsx from 'clsx'
import { ChevronDownIcon, HomeIcon, UserCircleIcon } from 'lucide-react'

import { DropdownMenu } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { useEmployer } from '../employer_onboarding/EmployerProvider'

export function RedirectToEmployerHomeButton () {
  const { assign } = useWindowLocation()

  const { employer } = useEmployer()
  if (!employer) {
    return null
  }

  const handleSaveAndExit = () => {
    // Redirect to employer homepage
    assign('/employers/employees')
  }

  const trigger = (
    <button
      aria-label='profile button'
      className={clsx(
        'appearance-none flex items-center gap-1 rounded-lg p-2 body text-gray-800 hover:bg-gray-100 focus-visible:bg-gray-100 data-[state*="open"]:bg-gray-200 data-[state*="open"]:hover:bg-gray-200 data-[state*="open"]:focus-visible:bg-gray-200 outline outline-offset-2 outline-2 outline-transparent focus-visible:outline-thatch-500'
      )}
    >
      <ChevronDownIcon aria-hidden size={16} />
      <UserCircleIcon aria-hidden size={24} />
    </button>
  )

  return (
    <div className='flex h-6 items-center'>
      <DropdownMenu align='end' trigger={trigger}>
        <DropdownMenu.Item leftIcon={HomeIcon} onSelect={handleSaveAndExit}>
          Save and exit
        </DropdownMenu.Item>
      </DropdownMenu>
    </div>
  )
}
